let zIndex = 0

export default {
  getNextZIndex: () => zIndex++,
}
